/* eslint-disable no-extend-native */
// We should work toward removing our Date prototype changes and moving all these functions to real modules

// This is used both in general and module JS, so it can't easily be extracted
window.formatMediumDate = function (theDate) {
    const medDate = new Date(theDate);
    return medDate.getShortMonthName() + ' ' + medDate.getDate() + ', ' + medDate.getFullYear();
};

Date.prototype.monthNames = [
    'January', 'February', 'March',
    'April', 'May', 'June',
    'July', 'August', 'September',
    'October', 'November', 'December',
];
Date.prototype.getUTCMonthName = function () {
    return this.monthNames[this.getUTCMonth()];
};
Date.prototype.getMonthName = function () {
    return this.monthNames[this.getMonth()];
};
Date.prototype.getShortMonthName = function () {
    return this.getMonthName().substr(0, 3);
};

Date.prototype.dayNames = [
    'Sunday', 'Monday', 'Tuesday',
    'Wednesday', 'Thursday', 'Friday',
    'Saturday',
];
Date.prototype.getDayName = function () {
    return this.dayNames[this.getDay()];
};
